import { useNavigate, useParams } from "react-router-dom"
import Button from "./Button"

const LockedStep = ({ stepName, message }) => {
  const navigate = useNavigate()
  const { token } = useParams()

  const handleGoToChecklist = () => {
    navigate(`/plan/${token}/checklist`)
  }

  return (
    <div className="flex min-h-screen flex-col justify-between bg-background">
      <div className="mx-auto w-full max-w-5xl p-12">
        <img className="mb-16 w-[300px]" src="/logo.png" alt="Encircled Logo" />

        <div className="flex flex-col items-center justify-center text-center">
          <div className="mb-8">
            <div className="mb-6 flex justify-center">
              <i className="fa-solid fa-lock text-6xl text-brand"></i>
            </div>
            <h2 className="mb-2 text-2xl font-bold text-black">
              {stepName || "This Step is Locked"}
            </h2>
            <p className="text-lg text-gray-600">
              {message || "You need to complete previous steps before accessing this one."}
            </p>
          </div>

          <div className="flex gap-4">
            <Button onClick={() => navigate(-1)} variant="secondary-outline">
              Go Back
            </Button>
            <Button onClick={handleGoToChecklist}>
              Go To Checklist
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LockedStep
